module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-76x76-680d6c44b8d9570a3f5bbd65deea2bc1.png";